import Chart from "react-apexcharts";

function ResultChart({ results }) {
  if (results.length < 2) return null;
  const values = results.map(r => parseFloat(r) || 0).reverse();
  
  const chartData = {
    series: [{
      name: 'Results',
      data: values
    }],
    options: {
      chart: {
        type: 'line',
        toolbar: { show: false }
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      markers: {
        size: 4,
        colors: ['#0d6efd'],
        strokeWidth: 0
      },
      colors: ['#0d6efd'],
      grid: {
        show: true,
        borderColor: '#e0e0e0',
        strokeDashArray: 3
      },
      xaxis: {
        labels: { 
          show: false
        },
        axisBorder: { show: false },
        axisTicks: { show: false }
      },
      yaxis: {
        labels: { 
          show: true,
          style: {
            fontSize: '10px',
            colors: ['#6c757d']
          }
        },
        axisBorder: { show: true }
      },
      dataLabels: {
        enabled: false
      },
      tooltip: { enabled: false }
    }
  };
  
  return <Chart options={chartData.options} series={chartData.series} type="line" height={100} width={150} />;
}

export default ResultChart;
